import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-sin-review-entry',
  templateUrl: './sin-review-entry.component.html',
  styleUrls: ['./sin-review-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SinReviewEntryComponent implements OnChanges {
  @Input() sin: string = '';
  @Input() disabled: boolean = false;

  private _sin = new BehaviorSubject('');
  public sin$ = this._sin as Observable<string>;

  private _showFullSin = new BehaviorSubject(false);
  public showFullSin$ = this._showFullSin as Observable<boolean>;

  public formattedSin$ = combineLatest([this.sin$, this.showFullSin$]).pipe(
    map(([sin, showFull]) => {
      if (!sin) return '';
      return showFull ? `${sin.slice(0, 3)} ${sin.slice(3, 6)} ${sin.slice(6)}` : `••• ••• ${sin.slice(6)}`;
    })
  );

  public iconSrc$ = this.showFullSin$.pipe(
    map(showFull => (showFull ? 'assets/icons/grey/Eye On.svg' : 'assets/icons/grey/Eye Off.svg'))
  );

  public toggleShowFullSin(): void {
    this.showFullSin$.pipe(take(1)).subscribe(value => {
      this._showFullSin.next(!value);
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.sin) {
      this._sin.next(this.sin);
    }
  }
}
